import React, { useEffect, useMemo } from 'react';
import qs from 'qs';
import tokenStorage from '../../utils/tokenStorage';
import Auth from '../../api/auth';
import { serverLogger } from '../../libs/datadog-logger/loggers/serverLogger';
import { getCorrelationId } from '../../libs/correlationId';
import './PaymentApplication.scss';

const PaymentMethodSuccessMessage = ({ location }) => {
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const applicationNumber = params?.app;
  const correlationId = useMemo(
    () => getCorrelationId(applicationNumber, params?.cid),
    [applicationNumber, params?.cid],
  );
  const successLogger = useMemo(
    () => serverLogger.child({ correlationId, appNumber: applicationNumber }),
    [correlationId, applicationNumber],
  );

  // Log that user has seen the success page
  useEffect(() => {
    let userName;
    try {
      const authData = Auth.getAuthData();
      userName =
        authData?.unique_name || authData?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    } catch {
      // Could not retrieve userName, will be undefined
    }

    successLogger.info('PaymentMethodSuccess: User viewed success page', {
      userName,
      appNumber: applicationNumber,
      flowStage: 'mop_success_page_viewed',
    });
  }, [applicationNumber, successLogger]);

  // Clean up authentication after success - this is a one-time flow
  useEffect(() => {
    const cleanupAuth = () => {
      try {
        // Clear all authentication data
        tokenStorage.clear();
        successLogger.info('PaymentMethodSuccess: Auth cleanup completed', {
          appNumber: applicationNumber,
          flowStage: 'auth_cleanup',
        });
      } catch (error) {
        successLogger.warn('PaymentMethodSuccess: Auth cleanup failed', {
          appNumber: applicationNumber,
          error: error.message,
        });
      }
    };

    // Clean up after a short delay to ensure the success message is visible
    const timeoutId = setTimeout(cleanupAuth, 2000);

    return () => clearTimeout(timeoutId);
  }, [applicationNumber, successLogger]);

  return (
    <div className="success-message-container">
      <div className="success-header">
        <h1 className="success-h1">Payment Method Successfully Updated</h1>
        <h2 className="success-h2">Application #: {applicationNumber}</h2>{' '}
        <div className="alert alert-success" style={{ marginTop: '2rem' }}>
          <p>You can now safely close this tab or window.</p>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodSuccessMessage;
